import { DateAxis, LineSeries, ValueAxis, XYChart } from "@amcharts/amcharts4/charts";
import { color, create } from "@amcharts/amcharts4/core";
import _ from "lodash";
import React, { Component } from "react";
import WebFont from "webfontloader";
import "../../../assets/styles/component/legend.scss";
import { CCS_ANALYSIS_COLORS } from "../../../constants";
import { generatePreviousRange } from "../../../pages/SEO/helpers/helpers";
import LoadingEllipsis from "../../Loading/LoadingEllipsis";
import { disposeChart } from "../helpers/chartHelpers";
import { configureDateAxis, configureValueAxis, legendConfiguration, lineSeriesConfiguration } from "../helpers/configurations";
import { oceChartConfiguration } from "../helpers/oceConfigurations";
import { ThemeInt } from "../helpers/types";
interface Props {
  data: Array<Record<string, number | string>>;
  seriesList: Array<{ name: string; field: string; color: string }>;
  theme: ThemeInt;
  chartId: string;
  dateValue: string;
  isLoading: boolean;
}

class DigitallyInfluencedSalesChart extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  chart!: XYChart;
  chartId = this.props.chartId;

  componentDidMount() {
    WebFont.load({
      custom: {
        families: ["nissan"],
        urls: ["../../../assets/fonts/fonts.css"],
      },
      // @ts-ignore
      active: this.initChart(),
      timeout: 8000,
    });
  }

  componentDidUpdate(prevProps: any) {
    //Handle refreshing the chart when the dataset changes
    if (!_.isEqual(prevProps, this.props)) {
      disposeChart(this.chartId).then((res) => {
        this.initChart();
      });
    }
  }

  componentWillUnmount() {
    disposeChart(this.chartId);
  }

  initChart() {
    const { data, seriesList, theme, dateValue } = this.props;

    const { current: currentLabel, previous: previousLabel } = generatePreviousRange(dateValue);

    this.chart = create(this.chartId, XYChart);
    oceChartConfiguration(this.chart);
    this.chart.data = data;
    this.chart.numberFormatter.numberFormat = "#.0";

    // Legend configuration
    this.chart.legend = legendConfiguration(theme);
    this.chart.colors.list = CCS_ANALYSIS_COLORS.map((item) => color(item));
    this.chart.legend.marginLeft = 0;

    // Create Axes
    const dateAxis = this.chart.xAxes.push(new DateAxis());
    configureDateAxis(dateAxis, theme);
    dateAxis.renderer.grid.template.location = 0;

    const dateAxis2 = this.chart.xAxes.push(new DateAxis());
    configureDateAxis(dateAxis2, theme);
    dateAxis2.renderer.grid.template.location = 0;
    dateAxis2.renderer.disabled = true;
    dateAxis2.syncWithAxis = dateAxis;

    const valueAxis = this.chart.yAxes.push(new ValueAxis());
    configureValueAxis(valueAxis, theme);
    valueAxis.renderer.labels.template.adapter.add("text", function (text) {
      return text + "%";
    });

    this.chart.data.sort(function (a, b) {
      //@ts-ignore
      return new Date(a.date) - new Date(b.date);
    });

    seriesList?.forEach(({ name, field, color: seriesColor }, idx) => {
      const series = this.chart.series.push(new LineSeries());
      if (field == "previous") {
        series.xAxis = dateAxis2;
      } else {
        series.xAxis = dateAxis;
      }
      if (field == "previous") {
        series.dataFields.dateX = "date1";
      } else {
        series.dataFields.dateX = "date";
      }
      if (field == "forecast") {
        series.strokeDasharray = "2,4";
      }
      series.fill = color(seriesColor);
      series.stroke = color(seriesColor);

      const circleBullet = lineSeriesConfiguration(series, {
        valueY: field,
        name: name == "current" ? currentLabel : name == "previous" ? previousLabel : name,
      });
      circleBullet.tooltipText = `[bold font-size: var(--regular_font_size)]{dateX.formatDate('MMM YYYY')}: [/ font-size: var(--regular_font_size)] {valueY.formatNumber('###,###')}%`;
    });
  }

  render() {
    return (
      <>
        <div className={"chartWrapper"}>
          <div id={this.props.chartId} data-test-id={this.props.chartId} className={"graph"} />
          <LoadingEllipsis isLoading={this.props.isLoading} />
        </div>
      </>
    );
  }
}

export default DigitallyInfluencedSalesChart;
